import React from "react";

/** Shared statutory form controls (EPF / ESI / PT / LWF / Bonus pages). */

export function Toggle({ checked, onChange, label }) {
  return (
    <div className="stat-toggle-row">
      <span style={{ fontSize: "0.8rem", color: "#334155" }}>{label}</span>
      <label className="stat-switch">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
        <span />
      </label>
    </div>
  );
}

export function Field({ label, children, error, hint, required, fieldKey }) {
  return (
    <div
      className={`stat-field${error ? " has-error" : ""}`}
      data-field-key={fieldKey || ""}
      tabIndex={-1}
    >
      <label>
        {label}
        {required ? <span className="stat-req"> *</span> : null}
      </label>
      {children}
      {hint ? <p className="stat-field-hint">{hint}</p> : null}
      {error ? <p className="stat-field-error" role="alert">{error}</p> : null}
    </div>
  );
}

export function focusFirstError(errors) {
  const keys = Object.keys(errors || {}).filter((k) => errors[k]);
  if (!keys.length) return;
  const first = keys[0];
  const wrap = document.querySelector(`[data-field-key="${first}"]`);
  if (wrap) {
    wrap.scrollIntoView({ behavior: "smooth", block: "center" });
    const control = wrap.querySelector("input, select, textarea");
    setTimeout(() => (control || wrap).focus?.(), 280);
  }
}
